module.exports = __webpack_public_path__ + "static/media/PlantinInfantMTStd.fd1a73d2.otf";